export const PARAM_CODE = 'code';
export const PARAM_STATE = 'state';
export const PARAM_ERROR = 'error';
export const PARAM_AUTH_REQ_ID = 'auth_req_id';
